// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1qpU_","unreadBadge":"styles_unreadBadge__2Uk--","modalContent":"styles_modalContent__36uHH","modal":"styles_modal__1gAKE"};